import { useRef, useEffect } from 'react';

import Hls from 'hls.js';
import useRoomContext from '@src/contexts/useRoomContext';

interface IProps {
  src: string; // Direct stream URL (e.g., HLS .m3u8)
}

const HLSVideoPlayer = ({ src }: IProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const { isLandscape, isMobileDevice } = useRoomContext();

  useEffect(() => {
    let hls: Hls | null = null;
    const video = videoRef.current;

    if (!video) return;

    const initPlayer = () => {
      if (Hls.isSupported()) {
        hls = new Hls();
        hls.loadSource(src);
        hls.attachMedia(video);
        hls.on(Hls.Events.MANIFEST_PARSED, () => {
          video.play();
        });
      } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
        // Native HLS support (Safari)
        video.src = src;
        video.addEventListener('loadedmetadata', () => {
          video.play();
        });
      } else {
        console.error('HLS is not supported in your browser.');
      }
    };

    initPlayer();

    return () => {
      if (hls) {
        hls.destroy();
      }
    };
  }, [src]);

  return (
    <video
      ref={videoRef}
      autoPlay
      playsInline
      muted
      style={{
        width: '100%',
        height: isMobileDevice && !isLandscape ? 'auto' : '100%',
        objectFit: 'fill',
      }}
    />
  );
};

export default HLSVideoPlayer;
